/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
//const 
import { bankAccountType } from '../../payment_const';
// material
import { Form, Grid, GridSet, GridItem, Link, Group, Icon, 
    ToolTip, TextField, FileUploader, SingleSelectDropDown } 
from '@insticator/insticator-ui'; // iui-material

//styles
import styles from './directdeposit_styles';
import injectSheet from 'react-jss';
import { validation } from '../../../../../../../utils/validation';
import { fetchACHInformation } from '../../../../../../../state/thunks/account';

const formName = 'ACH'

const bankAccountTypeOptions = [
  { name: 'Business checking', value:'BUSINESS_CHECKING' }, 
  { name: 'Business Savings', value: 'BUSINESS_SAVINGS' },
  { name: 'Personal checking', value:'PERSONAL_CHECKING' }, 
  { name: 'Personal Savings', value: 'PERSONAL_SAVINGS' }
]

/* ========== ~~~~~~~~~~ DIRECT DEPOSIT ~~~~~~~~~~ ========== */
const DirectDeposit = injectSheet(styles)((props) => {
  const dispatch = useDispatch()
  const { payments } = useSelector(state => state.account)

  const { achUUID, details, setDetails, onFormChange, onFormFileUpload, onFormFileDiscard, editable, isSaveClicked } = props

  useEffect(() => {
    if(achUUID) dispatch(fetchACHInformation(achUUID))
  },[achUUID, dispatch])

  useEffect(() => {
    if(payments.ach && achUUID) setDetails(payments.ach)
  }, [payments, achUUID, setDetails])

  const isValid = name => !achUUID ? (!isSaveClicked || validation[name].test.test(details[name])) : !editable || validation[name].test.test(details[name])

  const uploadFile = file => onFormFileUpload(file)

  const discardFile = () => onFormFileDiscard()

  return(
      <Form formName={formName} >
        <Grid klass={`directdeposit ${props.classes.directdeposit}`}>
          <GridSet align={`horizontal`} >
            <GridItem>
              <label className={'label'}>Bank Account Type</label>
              <SingleSelectDropDown 
                name={details.bankAccountType ? bankAccountType[details.bankAccountType] : 'Select bank account type'} 
                searchable={false} 
                onSelect={opt => onFormChange('bankAccountType', opt.value)} 
                items={bankAccountTypeOptions}
                valid={!achUUID ? (!isSaveClicked || !!details.bankAccountType) : !editable || !!details.bankAccountType}
                disabled={!editable}
              />
              </GridItem>
              <GridItem>
                <TextField 
                  type={`text`} name={`bankName`} value={details.bankName} valid={isValid('bankName')} 
                  formName={formName} placeholder={`Comerica Bank`} label={`Bank Name`} required 
                  handleChange={e => onFormChange('bankName', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
              <GridItem>
                <TextField type={`text`} name={`accountName`} value={details.accountName} valid={isValid('accountName')} 
                  formName={formName} placeholder={`Company name`} label={`Account Name (Company Name)`} required 
                  handleChange={e => onFormChange('accountName', e.target.value)} 
                  disabled={!editable}
                />
            </GridItem>
        </GridSet>
        <GridSet align={`horizontal`} >
              <GridItem>
                <TextField type={`text`} name={`routingCode`} value={details.routingCode} valid={isValid('routingCode')} 
                  formName={formName} placeholder={`101010101`} label={`Routing number`} required 
                  handleChange={e => onFormChange('routingCode', e.target.value)} 
                  disabled={!editable}
                />
              </GridItem>
              <GridItem>
                <TextField type={`text`} name={`accountNumber`} value={details.accountNumber} valid={isValid('accountNumber')} 
                  formName={formName} placeholder={`**** 1010`} label={`Bank Account Number`} required 
                  handleChange={e => onFormChange('accountNumber', e.target.value)} 
                  disabled={!editable}
                />
              </GridItem>
              <GridItem>
                <Group name={`upload-form valid-true`} >
                    <span>
                      W9 Form <ToolTip align={`right`} action={`click`} 
                                content={<p>Please make sure you are uploading a file in PDF format (we currently do not support other file formats).</p>}>
                                  <Icon name={`exclamation-circle`} />
                              </ToolTip>
                    </span>
                    <FileUploader disabled={!editable} uploadFile={uploadFile} discardFile={discardFile} 
                      maxSize={5000} supportedFileTypes={['application/pdf']} 
                      filePreviewText={details.w9FormUpdateDateTime}
                      fileName={details.w9FormName}
                      isValid={!achUUID ? (!isSaveClicked || !!(details.w9FormName || details.w9Form)) : !editable || !!(details.w9FormName || details.w9Form)}
                    />
                    <Link name={'w9formlink'} text={details.w9FormLink ? 'Download your W9 Form' : 'Download W9 Form Template'} 
                      variant={`primary`} type={`external`} action={details.w9FormLink ? details.w9FormLink : 'https://www.irs.gov/pub/irs-pdf/fw9.pdf'} 
                      icon={`arrow-down`} iconRight disabled={!editable}
                    />
                </Group>
              </GridItem>
          </GridSet>
      </Grid>
    </Form>
  );

})



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default DirectDeposit
